<template>
	<validation-observer ref="observer" v-slot="{ handleSubmit }">
		<b-form v-on:submit.stop.prevent="handleSubmit( onSubmit )">
			<b-form-row>
				<b-col md="10">
					<b-form-row>
						<b-col md="9">
							<validation-provider v-slot="validationContext" name="Prize Description" v-bind:rules="{ required: true }" vid="description">
								<b-form-input id="prize-description" v-model="prize.description" placeholder="Prize Description" tabindex="0" v-bind:state="getValidationState( validationContext )"></b-form-input>
								<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
							</validation-provider>
						</b-col>
						<b-col md="3">
							<validation-provider v-slot="validationContext" name="Prize Quantity" v-bind:rules="{ required: true, min_value: 1 }" vid="quantity">
								<b-form-input id="prize-quantity" v-model.number="prize.quantity" placeholder="##" type="number" v-bind:state="getValidationState( validationContext )"></b-form-input>
								<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
							</validation-provider>
						</b-col>
						<b-col md="12">
							<validation-provider v-slot="validationContext" :rules="{ required: true }" name="Prize Importance" vid="importance">
								<b-form-radio-group id="prize-importance" v-model="prize.importance" :state="getValidationState( validationContext )" name="importance">
									<b-form-radio value="high">High</b-form-radio>
									<b-form-radio value="medium">Medium</b-form-radio>
									<b-form-radio value="low">Low</b-form-radio>
									<b-form-invalid-feedback :state="getValidationState( validationContext )">
										{{ validationContext.errors[0] }}
									</b-form-invalid-feedback>
								</b-form-radio-group>
							</validation-provider>
						</b-col>
					</b-form-row>
				</b-col>
				<b-col md="2">
					<b-button :disabled="prize.project.locked" class="mr-2" pill type="submit" variant="success">
						<b-icon aria-hidden="true" icon="check"></b-icon>
					</b-button>
					<b-button :disabled="prize.project.locked" pill type="button" variant="danger" @click="onDelete">
						<b-icon aria-hidden="true" icon="trash"></b-icon>
					</b-button>
				</b-col>
			</b-form-row>
		</b-form>
	</validation-observer>
</template>

<script>
import { PROJECT_PRIZES_REMOVE, PROJECT_PRIZES_SAVE } from '../store/actions/project'

export default {
	name: 'PrizeTile',

	props: {
		value: Object,
	},

	data () {
		return {
			prize: this.value
		}
	},

	methods: {
		getValidationState ({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null
		},

		async onSubmit () {
			this.$refs['observer'].reset()

			this.$axios.put(`/prizes/${this.prize.id}`, this.prize)
				.then(response => {
					this.$store.commit(PROJECT_PRIZES_SAVE, response.data)
					this.$bvToast.toast('Your prize has been saved!', {
						title: 'Success!',
						autoHideDelay: 5000,
						variant: 'success'
					})
				})
		},

		async onDelete () {
			this.$bvModal.msgBoxConfirm(`Are you sure you want to delete '${this.prize.description}'?`)
				.then(answer => {
					if (answer) {
						this.$axios.delete(`/prizes/${this.prize.id}`)
							.then(() => {
								this.$store.commit(PROJECT_PRIZES_REMOVE, this.prize)
							})
					}
				})

		}
	}
}
</script>
